import React from 'react';
import styles from './BookingsBar.module.css';
import {Tooltip } from 'antd';
import { ImPower } from "react-icons/im";
import { LuCalendarClock, LuCalendarOff } from "react-icons/lu";


const BookingsBar = ({ timeFormatAmPm, connector }) => {
  const { bookings, bookingFilterTime } = connector;
  // console.log("connector in bookings bar: ", connector);


  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const currentDate = new Date();
    const dateToConvert = new Date(dateString);
    
    date.setHours(0, 0, 0, 0);
    currentDate.setHours(0, 0, 0, 0);

    const options = {
      hour: 'numeric',
      minute: 'numeric',
      hour12: timeFormatAmPm
    };

    let updatedFormat = dateToConvert.toLocaleTimeString(undefined, options);
    
    if (date.getTime() > currentDate.getTime()) {
      updatedFormat = updatedFormat + (' (+1)');
    }
    
    return updatedFormat;
}



  const startTime = new Date(bookingFilterTime.from).getTime();
  const endTime = new Date(bookingFilterTime.to).getTime();
  const total = endTime - startTime;

  let appendedArray = [];

  bookings.forEach((booking) => {
    const bookingStartTime = new Date(booking.startTime).getTime();
    const bookingEndTime = new Date(booking.endTime).getTime();

    let bookingStartPercentage = ((bookingStartTime - startTime) / total) * 100;
    let bookingEndPercentage = ((bookingEndTime - startTime) / total) * 100;

    // Clamp values between 0 and 100
    bookingStartPercentage = Math.max(0, Math.min(bookingStartPercentage, 100));
    bookingEndPercentage = Math.max(0, Math.min(bookingEndPercentage, 100));
    appendedArray.push({ start: bookingStartPercentage, end: bookingEndPercentage, type: 'utilized', time: { start: (booking.startTime), end: (booking.endTime) } });
  });

  // Fill the gaps with "unutilized" slots in a new array
  let newArray = [];
  let previousEnd = 0;
  let previousTimeEnd = new Date(bookingFilterTime.from);
  appendedArray.forEach((booking) => {
    if (booking.start > previousEnd) {
      // Fill the gap with an "unutilized" slot
      const unutilizedTime = { start: (previousTimeEnd), end: (booking.time.start) };
      newArray.push({ start: previousEnd, end: booking.start, type: 'unutilized', time: unutilizedTime });
    }
    // Add the utilized slot
    newArray.push(booking);
    previousEnd = booking.end;
    previousTimeEnd = booking.time.end
  });

  // Check for any gaps after the last booking
  if (appendedArray.length > 0 && previousEnd < 100) {
    const unutilizedTime = { start: (previousTimeEnd), end: (new Date(bookingFilterTime.to)) };
    newArray.push({ start: previousEnd, end: 100, type: 'unutilized', time: unutilizedTime });
  }

  return (
    <div className={styles['charger-block']}>
    
      <div className={styles['charger-properties']}>
        <div className={styles['charger-title']}><ImPower className={styles['thunderbolt']} /><b>{connector.charger.chargerTag}  {connector.noOfConnectorsInCharger !== 1 ? ` - #${connector.connectorNumber}` : ''}</b>
            {connector.nonReservable ?
             <Tooltip
                color={'#18365E'}
                placement="top"
                title={`Non-reservable charger`}
              >
                <LuCalendarOff className={styles['charger-type']} /> 
              </Tooltip>
            :
            <Tooltip
              color={'#18365E'}
              placement="top"
              title={`Reservable charger`}
            >
              <LuCalendarClock className={styles['charger-type']} />
            </Tooltip>
            }
        </div>
        <div className={`${styles['charger-title']} ${styles['right']}`}>
          <div >
            <b>Level 2</b>
            </div>
            <div className={styles['power-info']}>{connector?.power} kW</div>
          </div>
      </div>

      <div className={styles['progress-start-end']}>
        <span>{formatDate(bookingFilterTime.from)} (Today)</span>
        <span>{formatDate(bookingFilterTime.to)}</span>
      </div>
      <div className={`progress ${styles['progress']}`} >
        {
          newArray.length ? newArray.map((booking, index) => (
            <Tooltip
              color={booking.type === 'unutilized' ? '#50b965' : 'gray'}
              placement="top"
              title={`${booking.type.charAt(0).toUpperCase() + booking.type.slice(1)} ${formatDate(new Date(booking.time.start))} - ${formatDate(booking.time.end)}`}              key={index}
            >
              <div
                className={`progress-bar ${styles['progressbar-' + booking.type]}`}
                role="progressbar"
                style={{ width: ((booking.end - booking.start)) + '%' }}
                aria-valuenow={((booking.end - booking.start))}
                aria-valuemin="0"
                aria-valuemax="100"
              >
              </div>
            </Tooltip>
          )) :

            (
              <Tooltip
                color={'#50b965'}
                placement="top"
                title={`${'Unutilized'} ${formatDate(new Date(bookingFilterTime.from))} - ${formatDate(new Date(bookingFilterTime.to))}`}
              >
                <div
                  className={`progress-bar ${styles['progressbar-unutilized']}`}
                  role="progressbar"
                  style={{ width: '100%' }}
                  aria-valuenow={((100))}
                  aria-valuemin="0"
                  aria-valuemax="100"
                >
                </div>
              </Tooltip>

            )
        }
      </div>
    </div>
  );
};

export default BookingsBar;
